import Player from './player'

export default Player
